export const GA4_TRACKING_ID = "G-M5XWB7HD1P";

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  window.gtag("config", GA4_TRACKING_ID, {
    page_path: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ event_name, category, label, value }) => {
  window.gtag("event", event_name, {
    event_category: category,
    event_label: label,
    value,
  });
};
